import { cloneDeep } from "lodash";

export const setSurveyEmailNotifications = ({ notifications, email }) => {
  notifications.email = email;

  return cloneDeep(notifications);
};

export default setSurveyEmailNotifications;
